import React from "react";

const NothingSelected = () => {
	return (
		<div className="nothing__main-content">
			<p>
				Say something
				<br />
				create an entry!
			</p>
			<i className="far fa-star fa-4x mt-5"></i>
		</div>
	);
};

export default NothingSelected;
